// Example: Load Rails libraries in Vite.
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import * as Turbo from '@hotwired/turbo'

import '@primer/view-components/app/components/primer/alpha/modal_dialog'
import '@primer/view-components/app/components/primer/dialog_helper'
import '@primer/view-components/app/components/primer/alpha/x_banner'
import '@primer/view-components/app/components/primer/alpha/tool_tip'

import '../../../app/components/form_dialog'
import '../../../app/components/trips/date_picker'
import '../../components/primer/alpha/tree_view/tree_view'
import '../../components/primer/alpha/tree_view/tree_view_icon_pair_element'
import '../../components/primer/alpha/tree_view/tree_view_include_fragment_element'
import '../../components/primer/alpha/tree_view/tree_view_roving_tab_index'
import '../../components/primer/alpha/tree_view/tree_view_sub_tree_node_element'

document.addEventListener("turbo:before-stream-render", (event: Event) => {
  const target = event.target as HTMLElement
  const action = target.getAttribute('action')

  if (action === "redirect") {
    event.preventDefault();
    const template = target.querySelector("template");
    const url = template?.content.textContent?.trim();
    if (url) Turbo.visit(url);
  }
});

// @ts-ignore
Turbo.start()
